import axios from 'axios';
import { User } from '../types/user';
import { axiosInstance, API_URL } from './api_config';


export const login = async (username: string, password: string): Promise<User> => {
    const response = await axios.post(`${API_URL}/login`, { username, password });
    return response.data;
};

export const register = async (formData: any): Promise<User> => {
    const response = await axiosInstance.post(`${API_URL}/register`, 
      
      formData);
    return response.data;
};

export const fetchProfile = async (userId: string): Promise<User> => {
    const response = await axios.post(`${API_URL}/fetch_profile`, { user_id: userId });
    return response.data;
}

export const updateProfile = async (formData: any): Promise<User> => {
    const response = await axiosInstance.post(`${API_URL}/update_profile`, 
      
      formData);
    return response.data;
}